import extend from "servicestack/basic.controller.properties";

export default class BasicController {
  constructor() {
    extend(this);
  }
}
